document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on the lookbook page
  const isLookbookPage = window.location.pathname.includes('lookbook') || 
                        document.body.classList.contains('template-page-lookbook') ||
                        document.body.classList.contains('page-lookbook');
  
  if (isLookbookPage) {
    console.log('Lookbook page detected, initializing snap scrolling...');
    
    // Get all sections
    const sections = document.querySelectorAll('main > .section, .section');
    
    if (sections.length > 0) {
      console.log('Found', sections.length, 'sections for snap scrolling');
      
      // Simple and reliable scroll event listener
      let isScrolling = false;
      let scrollTimeout;
      
      window.addEventListener('scroll', function() {
        // Clear previous timeout
        if (scrollTimeout) clearTimeout(scrollTimeout);
        
        // Set timeout to end scrolling
        scrollTimeout = setTimeout(function() {
          // Find the section closest to the top of the viewport
          let closestSection = null;
          let minDistance = Infinity;
          
          sections.forEach(function(section) {
            const rect = section.getBoundingClientRect();
            const distance = Math.abs(rect.top);
            
            if (distance < minDistance) {
              minDistance = distance;
              closestSection = section;
            }
          });
          
          // Check if we're near the bottom of the page (footer area)
          const windowHeight = window.innerHeight;
          const documentHeight = document.documentElement.scrollHeight;
          const scrollPosition = window.pageYOffset + windowHeight;
          const isNearFooter = scrollPosition > documentHeight - 200;
          
          // Always snap to closest section if not near footer and more than 40px away
          if (closestSection && minDistance > 40 && !isNearFooter) {
            closestSection.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }, 100); // Consistent 100ms delay
      });
      
      // Add keyboard navigation
      document.addEventListener('keydown', function(e) {
        // Only handle keyboard navigation if we're not in an input field
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.contentEditable === 'true') {
          return;
        }
        
        if (e.key === 'ArrowDown' || e.key === 'PageDown') {
          e.preventDefault();
          const currentSection = getCurrentSection();
          console.log('Current section:', currentSection);
          
          if (currentSection) {
            const nextSection = getNextSection(currentSection);
            console.log('Next section:', nextSection);
            
            if (nextSection) {
              nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
              // If no next section, scroll to footer
              const footer = document.querySelector('footer') || document.querySelector('[data-footer]');
              if (footer) {
                footer.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }
          } else {
            // If no current section found, go to first section
            if (sections.length > 0) {
              sections[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        } else if (e.key === 'ArrowUp' || e.key === 'PageUp') {
          e.preventDefault();
          const currentSection = getCurrentSection();
          console.log('Current section (up):', currentSection);
          
          if (currentSection) {
            const prevSection = getPreviousSection(currentSection);
            console.log('Previous section:', prevSection);
            
            if (prevSection) {
              prevSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          } else {
            // If no current section found, go to last section
            if (sections.length > 0) {
              sections[sections.length - 1].scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        }
      });
      

      
      // Helper functions
      function getCurrentSection() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let currentSection = null;
        let minDistance = Infinity;
        
        sections.forEach(function(section) {
          const rect = section.getBoundingClientRect();
          const distance = Math.abs(rect.top);
          
          // Consider a section "current" if it's within 150px of the top (more sensitive)
          if (distance < minDistance && distance < 150) {
            minDistance = distance;
            currentSection = section;
          }
        });
        
        console.log('Found current section:', currentSection, 'with distance:', minDistance);
        return currentSection;
      }
      
      function getNextSection(currentSection) {
        const currentIndex = Array.from(sections).indexOf(currentSection);
        return sections[currentIndex + 1] || null;
      }
      
      function getPreviousSection(currentSection) {
        const currentIndex = Array.from(sections).indexOf(currentSection);
        return sections[currentIndex - 1] || null;
      }
      
      console.log('Snap scrolling initialized successfully!');
    } else {
      console.log('No sections found for snap scrolling');
    }
  }
}); 